import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { I18nNamespaceLoader } from './i18n-namespace.loader';
import { MILINCO_DEFAULT_LANG, MILINCO_SUPPORTED_LANGS } from './i18n-lang';

export { MILINCO_DEFAULT_LANG, MILINCO_SUPPORTED_LANGS } from './i18n-lang';

/** Carga i18n core antes del primer render (browser + SSR). */
export function initializeMilincoTranslate(): Promise<unknown> {
  const translate = inject(TranslateService);
  const namespaces = inject(I18nNamespaceLoader);
  translate.addLangs([...MILINCO_SUPPORTED_LANGS]);
  return firstValueFrom(
    translate.setFallbackLang(MILINCO_DEFAULT_LANG).pipe(
      switchMap(() => translate.use(MILINCO_DEFAULT_LANG)),
      tap(() => namespaces.markCoreLoaded(MILINCO_DEFAULT_LANG))
    )
  );
}
